
  import {
    mapSectionComponents,
    replaceCityDataInSections,
  } from '@/helper/SectionHelper';
  import {getMetaTags, replaceCityDataInMetaData} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'LandingPageEventjobsCities',
    components: {
      LazyHydrate,
    },
    async asyncData({app, route, error, $cachedStrapi, $growthbook}) {
      // Add grothbook to test different landingpage-variations
      let slug;
      switch ($growthbook.getFeatureValue('cro_landingpage_eventjobs')) {
        case 'v1':
          slug = 'landingpages-eventjobs-city-cro-v1';
          break;

        default:
          slug = 'landingpages-eventjobs-city';
      }

      const pagePromise = $cachedStrapi.findOne('pages', slug).catch((e) => {
        if (e.statusCode !== 404) {
          throw e;
        }
      });

      const cityPromise = $cachedStrapi
        .findOne('cities', 'eventjobs-' + route.params.city)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }

          return $cachedStrapi
            .findOne('cities', route.params.city)
            .catch((e) => {
              if (e.statusCode !== 404) {
                throw e;
              }
            });
        });

      const [page, city] = await Promise.all([pagePromise, cityPromise]);

      if (!scopeHelper(page, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }
      if (!scopeHelper(city, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'City not found'});
        return;
      }

      // Map section components and replace city data/placeholder
      let sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.landingpage_eventjobs'),
                  disabled: false,
                  to: app.localePath({
                    name: 'landingpages-eventjobs',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: city.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'landingpages-eventjobs-city',
                    params: {
                      city: city.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );
      sections = replaceCityDataInSections(sections, city);

      const metaData = replaceCityDataInMetaData(page.meta ?? {}, city);

      return {
        metaData,
        sections,
        city,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
        city: {},
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
    mounted() {
      // Aufruf im CSR für Tracking-Callback
      this.$growthbook.getFeatureValue('cro_landingpage_eventjobs');
    },
  };
